import { LOCALES } from 'i18n/locales';

export const characterCountIntl = {
    [LOCALES.ENGLISH]: {
        'characterCount.underCountMessage': 'You have {remainingCharacterCount} characters remaining',
        'characterCount.overCountMessage': 'You have {excessCharacterCount} characters too many'
    },
    [LOCALES.WELSH]: {
        'characterCount.underCountMessage': 'Mae gennych {remainingCharacterCount} o nodau dros ben',
        'characterCount.overCountMessage': 'Mae gennych {excessCharacterCount} o nodau\'n ormod'
    }
};
